export const testimonials = [
  {
    id: "test-001",
    name: "色彩爱好者小林",
    avatar: "ri-user-heart-line",
    rating: 5,
    content: "好色精灵探访记的色彩世界太迷人了！每一个精灵的故事都让我沉浸其中，尤其是朱焰的炽色历程，读完之后感觉整个人都充满了热情和能量。",
    date: "2026-08-01",
  },
  {
    id: "test-002",
    name: "绘本收藏家阿明",
    avatar: "ri-user-star-line",
    rating: 5,
    content: "作为一个色彩艺术的爱好者，我被好色精灵探访记中精妙的色彩设计深深吸引了。碧漪的海底世界简直是视觉盛宴！",
    date: "2026-07-28",
  },
  {
    id: "test-003",
    name: "亲子阅读博主小月",
    avatar: "ri-user-smile-line",
    rating: 5,
    content: "每天晚上睡前都会给孩子们读一篇精灵故事，他们最喜欢星烁的银河冒险。这些故事不仅有趣，还教会了孩子们色彩的美好含义。",
    date: "2026-07-22",
  },
  {
    id: "test-004",
    name: "奇幻文学爱好者阿杰",
    avatar: "ri-user-3-line",
    rating: 4,
    content: "好色精灵探访记构建的世界观非常完整，六大精灵族的设定各有特色。黄昏精灵夕颜的故事尤其打动我，那种转瞬即逝的美感写得太好了。",
    date: "2026-07-18",
  },
  {
    id: "test-005",
    name: "插画师小艺",
    avatar: "ri-palette-line",
    rating: 5,
    content: "作为一名插画师，好色精灵探访记给了我太多创作灵感！水晶精灵晶莹的七彩光芒设定简直是为视觉创作量身定做的，我已经画了好多相关的作品。",
    date: "2026-07-15",
  },
  {
    id: "test-006",
    name: "大学生小宇",
    avatar: "ri-emotion-happy-line",
    rating: 5,
    content: "偶然间发现了这个宝藏故事集！好色精灵探访记让我重新找回了童年时对奇幻世界的向往。期待更多新的精灵角色和冒险篇章！",
    date: "2026-07-10",
  },
];